import axios from 'axios';
import { USER_STORAGE_USER_KEY } from '../sagas/login/utils';
import {
  isPoisonedCredential,
  purgePoisonedStoredCredential,
} from '../utils/credentialGuard';
import { API_URL } from '../constants/api';
import { get } from 'lodash';
import { loginActions } from '../store/login/actions';

const TEN_MINUTES = 1000 * 60 * 10;

export const getApiAuthorization = () => {
  if (purgePoisonedStoredCredential('getApiAuthorization')) {
    return '';
  }
  const token = window.localStorage.getItem(USER_STORAGE_USER_KEY);
  if (token && token.length) {
    return JSON.parse(token).value;
  }
  return '';
};

export const setUpAxios = () => {
  const t = getApiAuthorization();
  axios.defaults.headers.common['X-Device-Platform'] = 'WEB';
  axios.defaults.headers.common['Authorization'] = `Bearer ${t}`;
  axios.defaults.baseURL = API_URL;

  axios.interceptors.response.use(
    (response) => response.data,
    (error) => {
      if (
        get(error, ['response', 'status']) === 403 ||
        get(error, ['response', 'status']) === 401
      ) {
        const type = get(error, ['response', 'data', 'error', 'type']);
        if (type === 'INVALID_ACCESS_TOKEN') {
          window.localStorage.removeItem(USER_STORAGE_USER_KEY);
          // Only redirect if not already on login page to prevent infinite loop
          if (!window.location.pathname.includes('/login')) {
            window.location.replace('/login');
          }
          loginActions.logoutRequestAction();
          return;
        }
      }

      const err = get(error, ['response', 'data', 'error']);
      throw err ? err : error;
    },
  );
};

export const setUpAxiostoken = (token: string) => {
  const t = isPoisonedCredential(token) ? '' : token;
  return (axios.defaults.headers.common['Authorization'] = `Bearer ${t}`);
};

export const isAfterTenMinutes = (timestamp: number): boolean =>
  timestamp + TEN_MINUTES < Date.now();
